import { render, staticRenderFns } from "./FolderConfirmChangeContactDialog.vue?vue&type=template&id=f51c8a88&scoped=true"
import script from "./FolderConfirmChangeContactDialog.vue?vue&type=script&lang=js"
export * from "./FolderConfirmChangeContactDialog.vue?vue&type=script&lang=js"
import style0 from "./FolderConfirmChangeContactDialog.vue?vue&type=style&index=0&id=f51c8a88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f51c8a88",
  null
  
)

export default component.exports